export const ERE_FACTOR = 0.332694

export const toStationVolumeInt = (value: unknown): number => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? Math.max(0, Math.floor(value)) : 0
  }

  if (typeof value === 'string') {
    const parsed = Number.parseInt(value, 10)
    return Number.isNaN(parsed) ? 0 : Math.max(0, parsed)
  }

  return 0
}

export const calculateCustomerStationTotals = (
  totalVolumeAllStationsKwh: number
) => {
  const normalizedTotal = Math.max(0, Math.floor(totalVolumeAllStationsKwh))

  return {
    total_volume_all_stations_kwh: normalizedTotal,
    calculated_eres: Math.floor(normalizedTotal * ERE_FACTOR)
  }
}
